import React, { ReactChild } from "react"
import { connect } from "react-redux"
import { APIAppInstanceModel } from "../../../../../../../../../Models/API/AppInstanceModel"
import { APIAppTemplateModel } from "../../../../../../../../../Models/API/AppTemplateModel"
import { AppDetailBase } from "../../../../AppDetailBase/AppDetailBase"
import { State } from "../../../../../../../../../Reducers"
import {
    ExampleData,
    ExampleDataProvider
} from "../../../../../../../../Providers/ExampleDataProvider/ExampleDataProvider"
import { getApiKey } from "../../../../../../../../../Helpers/Functions/Selectors/auth"
import { useAppInstance } from "../../../../../../../../../Hooks/useAppInstance"
import { useAppTemplate } from "../../../../../../../../../Hooks/useAppTemplate"
import { hasValue } from "../../../../../../../../../Models/Client/FetchState"

const ITEM_FORM_NAME = (appID: string) => `${appID}_add_item`

export interface InstructionsArgs {
    instance: APIAppInstanceModel
    apiKey?: string
    apiUrl: string
    template: APIAppTemplateModel
    example?: ExampleData
}

interface BaselineDataProps {
    orgUsername: string
    child: (args: InstructionsArgs) => JSX.Element
    renderSidebar: () => ReactChild | undefined
    id: string
    title: string
    breadcrumbs: string[]
}

interface StateProps {
    apiUrl: string
    apiKey?: string
    isValid: boolean
}

interface DispatchProps {}

export type Props = BaselineDataProps & StateProps & DispatchProps

export const BaselineDataBaseIsolated = ({
    orgUsername,
    id,
    child,
    title,
    breadcrumbs,
    apiKey,
    apiUrl,
    renderSidebar
}: Props) => {
    const instanceFetch = useAppInstance(id)
    const templateFetch = useAppTemplate(id)
    const instanceRender = () => {
        if (!hasValue(instanceFetch) || !hasValue(templateFetch)) {
            return null
        }

        const exampleRender = (example?: ExampleData) =>
            child({
                apiKey,
                apiUrl,
                instance: instanceFetch.value,
                example,
                template: templateFetch.value
            })

        return (
            <ExampleDataProvider
                render={exampleRender}
                instance={instanceFetch.value}
                template={templateFetch.value}
            />
        )
    }

    return (
        <AppDetailBase
            orgUsername={orgUsername}
            id={id}
            title={title}
            breadcrumbs={breadcrumbs}
            fixedContentWidth={true}
            render={instanceRender}
            renderSidebar={renderSidebar}
        />
    )
}

const mapStateToProps = (
    state: State,
    { id }: BaselineDataProps
): StateProps => {
    const inputRender = state.client.inputRender.entries[ITEM_FORM_NAME(id)]

    return {
        apiUrl: state.client.endpoints.apiUrl,
        apiKey: getApiKey(state),
        isValid:
            inputRender !== undefined ? inputRender.errors.length === 0 : false
    }
}

export const BaselineDataBase = connect(mapStateToProps)(
    BaselineDataBaseIsolated
)
